import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { ContactForm } from "@/components/ContactForm";
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import type { Database } from "@/integrations/supabase/types";
import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { SEO } from "@/components/SEO";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
type FAQ = Database['public']['Tables']['faqs']['Row'];
const Contact = () => {
  const navigate = useNavigate();
  const {
    data: faqs,
    isLoading
  } = useQuery({
    queryKey: ['faqs'],
    queryFn: async () => {
      const {
        data,
        error
      } = await supabase.from('faqs').select('*').order('display_order', {
        ascending: true
      });
      if (error) throw error;
      return data as FAQ[];
    }
  });
  return <div className="min-h-screen bg-black flex flex-col">
      <SEO />
      <Header />
      <main className="flex-grow container mx-auto px-4 pt-40 pb-12 relative">
        <div className="max-w-4xl mx-auto space-y-12">
          {/* Back Button */}
          

          {/* Contact Information Section */}
          <section className="relative mb-12">
            <div className="absolute inset-0 bg-gradient-to-r from-purple-500/10 to-pink-500/10 blur-3xl" />
            <div className="relative bg-gray-800/40 backdrop-blur-md rounded-lg p-8 border border-gray-700/50">
              <h2 className="text-2xl font-bold text-white mb-6">Contact Us</h2>
              <div className="space-y-4 text-gray-200">
                <p className="flex items-center gap-3">
                  <span className="text-xl">📤</span>
                  <span>support@slay.events</span>
                </p>
                <p className="flex items-center gap-3">
                  <span className="text-xl">📍</span>
                  <span>L7, 222 Exhibition Street, Melbourne Victoria 3000, Australia</span>
                </p>
              </div>
            </div>
          </section>

          <section className="relative">
            <div className="absolute inset-0 bg-gradient-to-r from-purple-500/10 to-pink-500/10 blur-3xl" />
            
            <h1 className="text-4xl font-bold text-white mb-8 tracking-tight relative">
              Frequently Asked Questions
            </h1>
            
            {isLoading ? <div className="space-y-4">
                {[1, 2, 3].map(i => <div key={i} className="bg-gray-800/50 backdrop-blur-md rounded-lg h-20 animate-pulse" />)}
              </div> : <Accordion type="single" collapsible className="space-y-4">
                {faqs?.map(faq => <AccordionItem key={faq.id} value={faq.id} className="group bg-gray-800/40 backdrop-blur-md rounded-lg border-none 
                             transition-all duration-300 hover:bg-gray-800/60
                             hover:shadow-[0_0_15px_rgba(139,92,246,0.3)]">
                    <AccordionTrigger className="text-white px-6 py-4 transition-all duration-300
                               hover:text-purple-300 data-[state=open]:shadow-lg">
                      {faq.question}
                    </AccordionTrigger>
                    <AccordionContent className="text-gray-300 px-6 overflow-hidden transition-all duration-300
                               data-[state=open]:animate-in data-[state=closed]:animate-out
                               data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0
                               data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95">
                      {faq.answer}
                    </AccordionContent>
                  </AccordionItem>)}
              </Accordion>}
          </section>

          <section className="relative">
            <div className="absolute inset-0 bg-gradient-to-r from-purple-500/5 to-pink-500/5 blur-2xl" />
            
            <h2 className="text-3xl font-bold text-white mb-6 tracking-tight relative">
              Didn't see your question?
            </h2>
            
            <div className="bg-gray-800/40 backdrop-blur-md rounded-lg p-6
                          shadow-[0_8px_30px_rgb(0,0,0,0.12)]
                          border border-gray-700/50">
              <ContactForm />
            </div>
          </section>
        </div>
      </main>
      <Footer />
    </div>;
};
export default Contact;